import router from './router'
import store from './store'
import { checkToken } from '@/api/common/public'
// import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { loginFn } from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'
import { SF_BUY } from '@/utils/constant'
import { getUrlKey, getHashParameters } from '@/utils'
import i18n from '@/lang'

NProgress.configure({ showSpinner: false })
const loginPage = window.localStorage.getItem('loginPage')
const sysCode = getUrlKey('sysCode') // url上源系统编码
console.log('%c Line:16 🍌 sysCode', 'color:#b03734', sysCode)
const lang = getUrlKey('lang') // url上语言编码
const fromUrl = getUrlKey('from') // url上源系统地址
console.log('%c Line:18 🍌 fromUrl', 'color:#6ec1c2', fromUrl)
const serviceUrl = getUrlKey('service') // url上源service地址
console.log('%c Line:20 🍣 serviceUrl', 'color:#e41a6a', serviceUrl)
// const isLogout = getUrlKey('isLogout') // url上第三方退出跳转过来
const retrieveType = getUrlKey('retrieveType') // url上第三方重置密码类型
const urlToken = getUrlKey('token') || ''
const whiteList = ['/replacetoken', '/preloading', '/authorize', '/old-login', '/login', '/logining', '/register', '/reset-password', '/account-conflict', '/email-link', '/', '/sys/change-password', '/sys/binding-email', '/sys/change-email', '/sys/binding-phone', '/sys/change-phone', '/sys/cancel-account', '/sys/set-name', '/terms']
const loginedList = ['/logining', '/email-link', '/customer-online', '/application-online', '/account-conflict']
if ((fromUrl || serviceUrl) && sysCode !== SF_BUY && !urlToken) {
  const local = loginFn.getUserInfo()
  const hash = getHashParameters()
  console.log('%c Line:30 🌶 hash', 'color:#6ec1c2', hash)
  if (local && local.token) {
    console.log('1.url上有参数，且本地缓存有token')
    if (serviceUrl) {
      store.dispatch('user/logout').then(() => {
        router.push({
          path: hash,
          query: { service: serviceUrl, sysCode, retrieveType, lang, from: fromUrl }
        })
      })
    } else {
      if (fromUrl) {
        // if (isLogout === '1' || isLogout === 1) {
        //   store.dispatch('user/logout').then(() => {
        //     router.push({
        //       path: hash,
        //       query: { sysCode, retrieveType, lang, from: fromUrl }
        //     })
        //   })
        // } else {
        store.dispatch('user/logout').then(() => {
          router.push({
            path: hash,
            query: { sysCode, retrieveType, lang, from: fromUrl }
          })
        })
        // }
      }
    }
  } else {
    // router.push({
    //   path: hash,
    //   query: { from: fromUrl, sysCode, retrieveType, lang }
    // })
  }
} else {
  router.beforeEach(async(to, from, next) => {
    if (window.__POWERED_BY_QIANKUN__) {
      next()
    } else {
      NProgress.start()
      // 同步title
      document.title = getPageTitle(to.meta.title)
      // 统一使用cookie
      const local = loginFn.getUserInfo()
      // 如果用户从邮箱链接中进入，直接跳入邮箱链接页面
      if (loginedList.indexOf(to.path) > -1) {
        next()
        NProgress.done()
        return
      }
      if (local && local.token) {
        if (whiteList.indexOf(to.path) !== -1) {
          // 若url上的sysCode存在的话,将lang参数作为当前界面的语言（由url上提供）
          if (lang) {
            i18n.locale = lang
            store.dispatch('site/setLanguage', lang)
            document.title = getPageTitle(to.meta.title)
            next()
          } else {
            // debugger
            next('/user/account-security')
          }
        } else {
        // 角色
          const hasRoles = store.getters.roles && store.getters.roles.length > 0
          if (hasRoles) {
            console.log(store.getters.roles)
            // debugger
            next()
          } else {
            try {
              await checkToken()
              const userInfo = await store.dispatch('user/getInfo')
              if (userInfo) {
                const accessRoutes = await store.dispatch('permission/generateRoutes', userInfo)
                // debugger
                if (accessRoutes) { router.addRoutes(accessRoutes) }
                next({ ...to, replace: true })
              } else {
              // 触发退出接口并清除cookie和本地缓存
              // await store.dispatch('user/logout')
                if (loginPage === '2') {
                  next(`/old-login?redirect=${to.path}`)
                } else {
                  next(`/login?redirect=${to.path}`)
                }
              }
            } catch (error) {
            // 触发退出接口并清除cookie和本地缓存
            // await store.dispatch('user/logout')
              if (loginPage === '2') {
                next(`/old-login?redirect=${to.path}`)
              } else {
                next(`/login?redirect=${to.path}`)
              }
            }
          }
        }
      } else {
        // if (sysCode && lang) {
        //   console.log('222---')
        //   i18n.locale = lang
        //   store.dispatch('site/setLanguage', lang)
        //   document.title = getPageTitle(to.meta.title)
        // }
        /* 无tonken时, 属于白名单内的路由直接跳转,非白名单跳转到ICAS登录界面*/
        if (whiteList.indexOf(to.path) > -1) {
          next()
        } else {
          // 无权限重定向到登录
          if (loginPage === '2') {
            next(`/old-login?redirect=${to.path}`)
          } else {
            next(`/login?redirect=${to.path}`)
          }
          NProgress.done()
        }
      }
    }
  })

  router.afterEach(() => {
    NProgress.done()
  })
}

